import React from "react";
import { X, Plus, Video } from "lucide-react";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";

// Detect which allowlisted provider a URL maps to (mirrors the backend
// MicrositeBlocks::EMBED_PROVIDERS). null = won't embed → shown as a warning.
function detectProvider(url) {
  let host;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
  if (/(^|\.)youtube\.com$|(^|\.)youtu\.be$/.test(host)) return "YouTube";
  if (/(^|\.)vimeo\.com$/.test(host)) return "Vimeo";
  if (/(^|\.)google\.com$/.test(host)) return "Google Maps";
  return null;
}

// A repeatable list of video/map URLs. Each row shows live provider detection so
// the broker knows before saving whether a link will embed.
export function VideoLinksEditor({ value = [], onChange }) {
  const rows = value.length ? value : [""];

  const update = (i, val) => {
    const next = [...rows];
    next[i] = val;
    onChange(next.filter((v, idx) => v.trim() || idx === i));
  };
  const remove = (i) => {
    const next = rows.filter((_, idx) => idx !== i);
    onChange(next);
  };
  const add = () => onChange([...value, ""]);

  return (
    <div className="space-y-2">
      {rows.map((url, i) => {
        const provider = url.trim() ? detectProvider(url) : null;
        return (
          <div key={i} className="space-y-1">
            <div className="flex items-center gap-2">
              <Video className="h-4 w-4 shrink-0 text-slate-400" />
              <Input
                value={url}
                onChange={(e) => update(i, e.target.value)}
                placeholder="Paste a YouTube, Vimeo, or Google Maps link"
              />
              {rows.length > 1 && (
                <Button type="button" variant="ghost" size="icon" onClick={() => remove(i)} aria-label="Remove link">
                  <X className="h-3.5 w-3.5 text-slate-400 hover:text-red-500" />
                </Button>
              )}
            </div>
            {url.trim() && (
              provider ? (
                <p className="pl-6 text-[12px] text-emerald-600">✓ {provider} — will embed on the page.</p>
              ) : (
                <p className="pl-6 text-[12px] text-amber-600">Not an embeddable host — this link will be skipped.</p>
              )
            )}
          </div>
        );
      })}
      <Button type="button" variant="outline" size="sm" className="gap-1" onClick={add}>
        <Plus className="h-3.5 w-3.5" /> Add another
      </Button>
    </div>
  );
}
